import { AnalyticsController } from '~hooks/useAnalytics/AnalyticsController';
import { Timesheet } from '~hooks/useTimesheets/models';

export function trackTimesheetSaved(timesheet: Timesheet) {
  const extractedAndSavedValues = [
    [timesheet.extractedNumber, timesheet.timesheetNumber],
    [timesheet.extractedDate?.valueOf(), timesheet.shiftDate?.valueOf()],
    [timesheet.extractedStartAt?.valueOf(), timesheet.startedAt?.valueOf()],
    [timesheet.extractedEndAt?.valueOf(), timesheet.endedAt?.valueOf()],
    [timesheet.extractedTotalMinutes, timesheet.totalMinutes],
    [timesheet.extractedNetMinutes, timesheet.netMinutes],
    [timesheet.extractedBreakMinutes, timesheet.breakMinutes],
  ].filter(([extractedValue]) => extractedValue !== null && extractedValue !== undefined);

  if (extractedAndSavedValues.length === 0) {
    return;
  }

  const isEdited = extractedAndSavedValues.some(
    ([extractedValue, savedValue]) => extractedValue !== savedValue,
  );

  AnalyticsController.track('ai_suggestion_resolved', {
    feature: 'timesheet',
    object_id: timesheet.id,
    outcome: isEdited ? 'edited' : 'accepted',
  });
}
